"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactModal = require("react-modal");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const movie_1 = require("@dialogexe/cw-website-store/movie");
const watchList_1 = require("@dialogexe/cw-website-store/watchList");
const userProfile_1 = require("@dialogexe/cw-website-store/userProfile");
const cw_component_authentication_1 = require("@dialogexe/cw-component-authentication");
const star = `\u2605`;
const plus = `\u002B`;
const checkMark = `\u2713`;
class MovieCover extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            videoOpen: false,
            isUserLoggedIn: false,
            loginModalOpen: false
        };
        this.componentDidMount = () => {
            this.props.getMovieInfoAction.fetchMovieInfo(this.props.reference);
            if (typeof window !== 'undefined' && window.localStorage) {
                const profile = JSON.parse(localStorage.getItem("cw-profile-new"));
                if (profile && profile.token) {
                    this.setState({ isUserLoggedIn: true }, () => {
                        this.props.getWatchListAction.fetchWatchList();
                    });
                }
            }
        };
        this.isMovieInWatchList = () => {
            const myWatchList = this.props.watchList;
            const currentMovie = this.props.movieInfo;
            return myWatchList.some(a => a.movieId === currentMovie.movieId);
        };
        this.handleDisplayLoginModal = () => {
            this.setState({ loginModalOpen: true });
        };
        this.addToWatchList = () => {
            if (!this.isMovieInWatchList()) {
                this.props.addMovieToWatchListAction.addToWatchList(this.props.movieInfo);
            }
        };
        this.renderAddToWatchList = () => {
            const isMovieInWatchList = this.isMovieInWatchList();
            return (React.createElement("div", null,
                React.createElement("span", { className: "interest-icon" }, isMovieInWatchList ? checkMark : plus),
                "Interessert"));
        };
        this.handleCloseLoginModal = () => {
            this.setState({ loginModalOpen: false });
            this.props.userProfileAction.deleteLoginFailedError();
        };
        this.handleLogin = (email, password) => {
            this.props.userProfileAction.fetchUserProfile(email, password);
        };
        this.handleForgotPassword = (email) => {
            this.props.userProfileAction.requestNewPassword(email);
        };
        this.openVideo = () => {
            this.setState({
                videoOpen: true
            });
        };
        this.closeVideo = () => {
            this.setState({
                videoOpen: false
            });
        };
    }
    render() {
        const { video, image, title, movieInfo, reference } = this.props;
        const { isUserLoggedIn } = this.state;
        if (!image && !title) {
            return (React.createElement("div", null));
        }
        return (React.createElement("div", { className: `MovieCover ${image ? '' : 'has-no-image'}`, "data-edi": reference },
            React.createElement("div", { className: `image ${image ? '' : 'is-blank'}`, style: { backgroundImage: image ? `url("${image}")` : null } },
                React.createElement("div", { className: "container" },
                    video.key && (React.createElement("div", { className: "video-button" },
                        React.createElement("button", { className: "icon-button is-huge", onClick: this.openVideo },
                            React.createElement("img", { src: icons_1.playIcon, alt: "" })))),
                    title && (React.createElement("h1", { className: "title" }, title)),
                    React.createElement("div", { className: "film" },
                        React.createElement("div", { className: "film film-rating" }, movieInfo && movieInfo.rating > 0 ? `${star} ${movieInfo.rating} / 6 (${movieInfo.ratingCount} vurderinger)` : `${star} 0 vurderinger`),
                        React.createElement("div", { className: `film film-watch-list ${this.isMovieInWatchList() ? 'added' : ''}`, onClick: isUserLoggedIn ? this.addToWatchList : this.handleDisplayLoginModal }, this.renderAddToWatchList()))),
                video.key && (React.createElement(ReactModal, { isOpen: this.state.videoOpen, ariaHideApp: false, className: "modal", overlayClassName: "modal-overlay", portalClassName: "modal-portal", shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, onRequestClose: this.closeVideo },
                    React.createElement("div", { className: "embedded-player" },
                        React.createElement("iframe", { src: this.getVideoUrl(), frameBorder: "0" }))))),
            this.state.loginModalOpen &&
                React.createElement(cw_component_authentication_1.default, { onClose: this.handleCloseLoginModal, onRequestClose: this.handleCloseLoginModal, onSubmit: this.handleLogin, onForgotPassword: this.handleForgotPassword })));
    }
    getVideoUrl() {
        const { provider, key } = this.props.video;
        switch (provider) {
            case 'youtube':
                return `https://youtube.com/embed/${key}?autoplay=1&fs=1`;
            case 'vimeo':
                return `https://player.vimeo.com/video/${key}`;
            default:
                throw new Error(`Video provider "${provider}" is not supported.`);
        }
    }
}
exports.MovieCover = MovieCover;
exports.default = react_redux_1.connect((state) => ({
    watchList: state.watchList.items,
    movieInfo: state.movie.movieInfo,
    userProfile: state.userProfile
}), (dispatch) => ({
    getMovieInfoAction: redux_1.bindActionCreators(movie_1.actionCreators, dispatch),
    addMovieToWatchListAction: redux_1.bindActionCreators(watchList_1.actionCreators, dispatch),
    getWatchListAction: redux_1.bindActionCreators(watchList_1.actionCreators, dispatch),
    userProfileAction: redux_1.bindActionCreators(userProfile_1.actionCreators, dispatch)
}))(MovieCover);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-movie-cover/MovieCover.tsx